import { FeeMonitor } from '@exodus/asset-lib'
import assert from 'minimalistic-assert'

import { fromHexToString } from './number-utils.js'

/**
 * Generic eth server based fee monitor.
 *
 * Compatible with all servers, clarity, magnifier and api-coin (they all implement the gasPrice method).
 *
 * Usage in the index files:
 *
 * const api = {
 *  ...
 *  createFeeMonitor: serverBasedFeeMonitorFactoryFactory({ interval: '50s', server, assetName: base.name }),
 *  ...
 * }
 */

export const serverBasedFeeMonitorFactoryFactory = ({
  assetName,
  interval,
  eip1559Enabled,
  server,
}) => {
  assert(assetName, 'assetName is required')
  assert(server, 'server is required')

  const FeeMonitorClass = class ServerBaseEthereumFeeMonitor extends FeeMonitor {
    constructor({ updateFee }) {
      assert(updateFee, 'updateFee is required')
      super({
        updateFee,
        assetName,
        interval,
      })
    }

    async fetchFee() {
      const gasPrice = fromHexToString(await server.getGasPrice())

      const baseFeePerGas = eip1559Enabled ? `${await server.getBaseFeePerGas()} wei` : undefined

      return {
        gasPrice: `${gasPrice} wei`,
        baseFeePerGas,
      }
    }
  }
  return (...args) => new FeeMonitorClass(...args)
}
